import { render } from "./Aside.vue?vue&type=template&id=c6846166&scoped=true"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"

import "./Aside.vue?vue&type=style&index=0&id=c6846166&scoped=true&lang=css"

import exportComponent from "E:\\学习资料\\项目\\Vue-Springboot-Library-main\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6846166"]])

export default __exports__